import axios from 'axios';
import config from '../../../config';
import { Applicant } from '../types';
import {
  AlreadyRegisteredException,
  BadRequestException,
  ExpiryAlreadyResetException,
  InternalErrorException,
  NotFoundException,
  UnprocessableEntityException,
} from './error';

const applicantsApi: string = config.apiEndpoints.applicants;
const applicantsEndpoint: string = `${applicantsApi}/applicants`;

export interface ApplicantsApi {
  addApplicant: (applicant: Applicant) => Promise<void>;
  withdraw: (email: string) => Promise<void>;
  keepAlive: (email: string, token: string) => Promise<void>;
}

const postApplicant = async (created: Applicant): Promise<void> => {
  await axios.post(`${applicantsEndpoint}`, created);
};

const deleteApplicantByEmail = async (email: string): Promise<void> => {
  await axios.delete(
    `${applicantsEndpoint}/email/${config.conference}/${email}`,
  );
};

const keepApplicantAlive = async (
  email: string,
  token: string,
): Promise<void> => {
  await axios.put(`${applicantsEndpoint}/${config.conference}/reset-expiry`, {
    conferenceId: config.conference,
    email: email,
    token: token,
  });
};

export class Applicants implements ApplicantsApi {
  public async addApplicant(applicant: Applicant): Promise<void> {
    const toPut: Applicant = { ...applicant };
    toPut.index = undefined;
    delete toPut.index;
    await postApplicant(applicant).catch((e) => {
      console.error(e);
      if (e.message.endsWith('409')) {
        throw new AlreadyRegisteredException();
      } else if (e.message.endsWith('400')) {
        throw new BadRequestException();
      } else throw new InternalErrorException();
    });
  }
  public async withdraw(email: string): Promise<void> {
    await deleteApplicantByEmail(email).catch((e) => {
      console.error(e);
      if (e.message.endsWith('404')) {
        throw new NotFoundException();
      } else if (e.message.endsWith('400')) {
        throw new BadRequestException();
      } else throw new InternalErrorException();
    });
  }
  public async keepAlive(email: string, token: string): Promise<void> {
    await keepApplicantAlive(email, token).catch((e) => {
      console.error(e);
      if (e.message.endsWith('404')) {
        throw new NotFoundException();
      } else if (e.message.endsWith('400')) {
        throw new BadRequestException();
      } else if (e.message.endsWith('422')) {
        throw new UnprocessableEntityException();
      } else if (e.message.endsWith('409')) {
        throw new ExpiryAlreadyResetException();
      } else throw new InternalErrorException();
    });
  }
}
